<template>
  <div>
    <div v-if="budget" class="containerFull form-row">
      <div class="col-md-4">
        <h3>Informações do Orçamento</h3>
        <hr>
        <span><b>Customizada:</b> {{ budget.custom ? 'Sim' : 'Não'}}</span><br>
        <span><b>Data/Hora:</b> {{ formatDate(budget.created_at) }}</span><br>
        <span><b>Cliente:</b> {{ budget.username.toUpperCase() }}</span><br>
        <span><b>Empresa:</b> {{ budget.company || 'Não informado.'}} </span><br>
        <span><b>Serviço:</b> {{ budget.service.name }} {{ budget.amount }} {{ transliterateServiceMetric(budget.service.metric) }}</span><br>
        <span><b>Origem:</b> {{ budget.howDidMeetUs }}</span><br>
        <span><b>Finalidade:</b> {{ budget.finality.name }}</span><br>
        <span><b>Idioma:</b> {{ budget.language.name }}</span><br>
        <span><b>Telefone:</b> {{ budget.phone }}</span><br>
        <span><b>Observação:</b> {{ budget.observation || 'Sem observação.' }}</span>
      </div>
      <div v-if="!budget.custom" class="resultOrcamento desktop hidden-xs hidden-sm col-md-8">
        <h3>Propostas</h3>
        <hr>
        <div class="row">
          <div class="col-md-2 tbHeader">
            <div class="menuInfo">
              <div class="tempoAudio">
                <p class="budget-service-name">{{ budget.service.name }}</p>
                <span class="budget-amount">{{ budget.amount }} {{ transliterateServiceMetric(budget.service.metric) }}</span>
              </div>
              <div class="titulos">
                <h3>À vista</h3>
              </div>
              <div class="titulos">
                <h3 style="height: 43px;">Parcelado</h3>
                <p class="budget-max-installment">{{ maxInstallment(budget.maxInstallment) }}</p>
              </div>
              <div class="titulos">
                <h3 style="height: 50px;">Prazo</h3>
                <p>dias úteis</p>
              </div>
            </div>
          </div>
          <div class="col-md-10 tbBody">
            <div class="row proposals-table">
              <div v-for="(proposal, i) in budget.proposals" :key="i" class="col-md-3 ">
                <form class="areaProposta removeBottomLeftRadius" v-bind:id="proposal.plan">
                  <h3 :style="{'background-color': getPlanColor(proposal.plan)}">{{ proposal.plan.toUpperCase() }}</h3>
                  <div class="titulo">
                    <p style="border-top: none;">{{ formatMoney(proposal.cashPirce) }}</p>
                  </div>
                  <div class="titulo" style="height: 79px;">
                    <p>{{ formatMoney(proposal.installmentPrice) }}</p>
                  </div>
                  <div class="titulo">
                    <p>{{ proposal.deadline }}</p>
                  </div>
                  <div></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'budget-viewer',
  props: {
    budget: {
      type: Object,
    },
  },
  data() {
    return {

    };
  },
};
</script>
<style scoped>
  .resultOrcamento .menuInfo{
    background:#1a2038;
    margin-top:1px;
  }
  .resultOrcamento .menuInfo.tituloMobile{
    display: none;
  }
  .resultOrcamento .menuInfo .tempoAudio{
    height: 66px;
    text-align: center;
    padding-top: 14px;
    font-size: 12px;
  }
  .resultOrcamento .menuInfo .tempoAudio p{
    color:#e6d03d;
    margin:0;
  }
  .resultOrcamento .menuInfo .tempoAudio span{
    color:#e6d03d;
    font-weight: bold;

  }
  .resultOrcamento .menuInfo .titulos h3{
    color:#fff;
    font-size: 16px;
    text-align: center;
    margin:0;
    height: 69px;
    border-top: solid 1px #ccc;
    line-height: 63px;
  }
  .resultOrcamento .menuInfo .titulos p{
    text-align: center;
    color:#fff;
    font-size: 14px;
  }
  .resultOrcamento .areaProposta{
    text-align: center;
    min-height: 250px;
    border-radius: 5px;
    background: #fff;
  }
  .resultOrcamento .areaProposta h3{
    margin:0;
    border-bottom: solid 1px #ccc;
    height: 68px;
    line-height: 68px;
    color: #fff;
    font-size: 15px;
    font-weight: bold;
  }
  .resultOrcamento .areaProposta .titulo{
    height: 70px;
    border-bottom: solid 1px #ccc;
    line-height: 70px;

  }
  .resultOrcamento .areaProposta .titulo p{
    margin:0;
    font-size: 16px;
  }
  .resultOrcamento .areaProposta .titulo strong{

  }

  .resultOrcamento .areaProposta .areaProposta{
    cursor:pointer;
  }
  .resultOrcamento .areaProposta .enviarArquivos p{
    margin: 0;
  }
  .resultOrcamento .areaProposta .enviarArquivos a{
    margin: 0;
    display: block;
    padding: 20px;
    color: #1a203a;
    text-transform: uppercase;
    font-weight: 800;
    transition:All .5s ease;
    -webkit-transition:All .5s ease;
    -moz-transition:All .5s ease;
    -o-transition:All .5s ease;
  }
  .resultOrcamento .areaProposta:hover a{
    color: #fff;
    background: #1a203a;
    transition:All .5s ease;
    -webkit-transition:All .5s ease;
    -moz-transition:All .5s ease;
    -o-transition:All .5s ease;
  }

  @media(max-width: 991px){
    .resultOrcamento .areaProposta .enviarArquivos a {
      border: solid #1a203a 1px;
      border-radius: 5px;
    }

    .resultOrcamento .menuInfo{
      display: none;
    }
    .resultOrcamento .menuInfo.tituloMobile{
      display: block;
    }
    .resultOrcamento .areaProposta{
      padding:10px;
      margin: 20px auto;
      width: 90%;
    }
    .resultOrcamento .menuInfo .tempoAudio {
      -webkit-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.75);
      box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.75);
    }
  }
  @media(max-width: 768px){

    .formularioOrcamento h2{
      color: #fff;
    }
    .formularioOrcamento span{
      color: #fff;
    }
    .formularioOrcamento button,.formularioOrcamento a{
      border: solid #ccc 1px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Budgets/BudgetViewer.vue